/** Display applicability is shared by tables, tags and structured data. */
export type VehicleIdentity = { classCode?: string | null; categoryCode?: string | null };
export function vehicleApplicability(vehicle: VehicleIdentity) {
  const unpowered =
    ['Trailer', 'SemiTrailer'].includes(vehicle.classCode ?? '') ||
    (vehicle.classCode === 'Motorhome' &&
      ['Caravan', 'CabinMotorhome', 'MobileHome'].includes(vehicle.categoryCode ?? ''));
  const bicycle = vehicle.classCode === 'EBike';
  return { powered: !unpowered, combustion: !unpowered && !bicycle, tractionBattery: !unpowered && !bicycle, bicycle };
}
export function vehicleFieldApplies(vehicle: VehicleIdentity, field: string): boolean {
  const a = vehicleApplicability(vehicle);
  if (['fuel', 'cubicCapacity', 'cylinder', 'fuelTankVolume', 'envkvPetrolType'].includes(field)) return a.combustion;
  if (['power', 'gearbox', 'drive', 'driveType', 'otherEnergySource'].includes(field)) return a.powered;
  if (
    [
      'battery',
      'batteryCapacity',
      'chargingTime',
      'chargingTimeFast',
      'plugTypes',
      'batteryWarranty.years',
      'batteryWarranty.mileage',
      'batteryStateOfHealth.capacity',
      'batteryStateOfHealth.documentUrl',
      'bidirectionalChargingTypes'
    ].includes(field)
  )
    return a.tractionBattery;
  if (
    [
      'batteryCapacityWh',
      'frameShape',
      'frameMaterial',
      'frameHeight',
      'wheelSize',
      'numberOfGears',
      'batteryPosition',
      'batteryManufacturer',
      'motorPosition',
      'bikeSuitableFor',
      'bikeGearType'
    ].includes(field)
  )
    return a.bicycle;
  return true;
}
